import home from '@/router/routes/dashboard/home'
import childrenList from '@/router/routes/dashboard/childrenList'
import childCard from '@/router/routes/dashboard/childCard'
import paymentsList from '@/router/routes/dashboard/paymentsList'
import paymentCard from '@/router/routes/dashboard/paymentCard'
import previousEditions from '@/router/routes/dashboard/previousEditions/previousEditions'

const DashboardView = () => import('@/views/DashboardView.vue')

export default {
  path: '/',
  component: DashboardView,
  children: [home, ...childrenList, ...childCard, paymentsList, paymentCard, ...previousEditions]
}
